import { create } from 'zustand';
import { Session, Therapist } from '../../../core/types';
import * as api from '../../../core/api/services';
import { storageMgt } from '../../../core/utils/storage';
import { User } from '../../../core/types';

interface AppointmentsState {
  sessions: Session[];
  isLoading: boolean;

  fetch: () => Promise<Session[]>;
  bookSession: (data: Session) => Promise<api.BookSessionResponse>;
  cancelSession: (id: string, reason: string) => Promise<any>;
  fetchTherapistSessions: (therapistId: string) => Promise<Session[]>;
  fetchTherapistInfo: (id: string) => Promise<Therapist>;
  rateTherapist: (data: any) => Promise<any>;
  retrieve: () => User | null;
}
const initialTherapist: Therapist = { name: '', rate: 0 };

export const useAppointmentsStore = create<AppointmentsState>((set) => ({
  sessions: [],
  isLoading: false,

  fetch: async () => {
    set({ isLoading: true });
  
    try {
      const user = storageMgt.getUser();
  
      if (!user?.id) {
        set({ isLoading: false });
        return [];
      }
  
      const result = await api.fetchSessionsByCustomer(user.id);
  
      set({
        sessions: result,
        isLoading: false,
      });
  
      return result;
    } catch (error) {
  
      set({ isLoading: false });
  
      return [];
    }
  },

  // bookSession: async (data: Session) => {
  //   try {
  //     return await api.bookSession(data);
  //   } catch {
  //     return {};
  //   }
  // },
bookSession: async (data: Session) => {
  return await api.bookSession(data);
},
  cancelSession: async (id: string, reason: string) => {
    try {
      return await api.cancelSession(id, reason);
    } catch {
      return null;
    }
  },

  fetchTherapistSessions: async (therapistId: string) => {
    try {
      return await api.fetchTherapistSessions(therapistId);
    } catch {
      return [];
    }
  },

  fetchTherapistInfo: async (id: string) => {
    try {
      return await api.fetchTherapistById(id);
    } catch {
      return initialTherapist;
    }
  },

  rateTherapist: async (data: any) => {
    try {
      return await api.rateTherapist(data);
    } catch {
      return null;
    }
  },

  retrieve: () => storageMgt.getUser(),
}));
